import axios from 'axios';
import base64url from 'base64url';
import { JWTOKEN, LANGUAGE, ACCESS_TOKEN } from '../constants';
import { performRefreshTokenRequest } from '../../scenes/OIDC/oidcHelpers';
import { apiUrl, login } from './../../settings/settings';

const hasStoredLocale = () => sessionStorage.getItem(LANGUAGE.LANG_KEY) !== undefined
    && sessionStorage.getItem(LANGUAGE.LANG_KEY) !== null
    && sessionStorage.getItem(LANGUAGE.LANG_KEY) !== LANGUAGE.UNDEFINED
    && sessionStorage.getItem(LANGUAGE.LANG_KEY) !== LANGUAGE.NULL
    && sessionStorage.getItem(LANGUAGE.LANG_KEY).trim() !== LANGUAGE.EMPTY;
const isLocaleEmpty = Locale => Locale === undefined
    || Locale === null
    || Locale === LANGUAGE.UNDEFINED
    || Locale === LANGUAGE.NULL
    || Locale.trim() === LANGUAGE.EMPTY;
const getLocale = Locale => (isLocaleEmpty(Locale) ? LANGUAGE.DEFAULT_LANG : Locale);
const getStoredLocale = () => (hasStoredLocale() ? sessionStorage.getItem(LANGUAGE.LANG_KEY) : LANGUAGE.DEFAULT_LANG);

const axiosRequest = (url, token, method, data, responseType, contentType, Locale) => (
  axios({
    method,
    url: `${apiUrl}/${url}`,
    headers: {
      'Content-Type': contentType,
      Authorization: `Bearer ${token}`,
      Locale: `${getLocale(Locale)}`
    },
    data,
    responseType: responseType,
    withCredentials: false,
    timeout: 50000,
    maxBodyLength: 100000000,
    maxContentLength: 100000000,
    validateStatus: (status) => {
      return status < 500; // Resolve only if the status code is less than 500
    },
  })
);

const defaultApiCall = (url, method = 'get', data = {}, responseType = null, contentType = 'application/json') => {
  const jwToken = sessionStorage.getItem(JWTOKEN);

  const token = JSON.parse(jwToken).token;
  const refreshToken = JSON.parse(jwToken).refreshToken;
  const base64Exp = token.split('.')[1];
  const base64ExpDec = JSON.parse(base64url.decode(base64Exp));
  const expDate = (base64ExpDec.exp * 1000);
  const Locale = getStoredLocale();
  const tokenIsExpired = expDate < Date.now();
  if (tokenIsExpired) {
    const tokenUrl = 'auth/token';
    return axiosRequest(tokenUrl, refreshToken, method, data, responseType, contentType, Locale)
      .then((response) => {
        sessionStorage.setItem(JWTOKEN, JSON.stringify(response.data));
        const newToken = response.data.token;
        return axiosRequest(url, newToken, method, data, responseType, contentType, Locale);
      })
      .catch(error => error);
  }

  return axiosRequest(url, token, method, data, responseType, contentType, Locale);
};

const msalApiCall = (url, method = 'get', data = {}, responseType = null, contentType = 'application/json') => {
  const jwToken = sessionStorage.getItem(JWTOKEN);

  const base64Exp = jwToken.split('.')[1];
  const base64ExpDec = JSON.parse(base64url.decode(base64Exp));
  const expDate = (base64ExpDec.exp * 1000);
  const Locale = getStoredLocale();
  const tokenIsExpired = expDate < Date.now();
  if (tokenIsExpired) {
    // TODO - PG - For Msal this is not how we refresh the token
    console.log('Need to refresh the token!');
  }

  const response = axiosRequest(url, jwToken, method, data, responseType, contentType, Locale);
  return response;
};


const oidcApiCall = (url, method = 'get', data = {}, responseType = null, contentType = 'application/json') => {
  let accessToken = sessionStorage.getItem(ACCESS_TOKEN);
  const base64Exp = accessToken.split('.')[1];
  const base64ExpDec = JSON.parse(base64url.decode(base64Exp));
  const expDate = (base64ExpDec.exp * 1000);
  const tokenIsExpired = expDate < Date.now();
  const Locale = getStoredLocale();
  if (tokenIsExpired) {
    return performRefreshTokenRequest().then(() => {
      // The access token was refreshed in local storage, we should get the last one
      accessToken = sessionStorage.getItem(ACCESS_TOKEN);
      return axiosRequest(url, accessToken, method, data, responseType, contentType, Locale);
    }
    );
  }
  return axiosRequest(url, accessToken, method, data, responseType, contentType, Locale);
};


const apiCall = (url, method = 'get', data = {}, responseType = null, contentType = 'application/json') => {
  if (login.authType === 'MSAL') {
    return msalApiCall(url, method, data, responseType, contentType);
  } else if (login.authType === 'OIDC') {
    return oidcApiCall(url, method, data, responseType, contentType);
  }
  return defaultApiCall(url, method, data, responseType, contentType);
};

export { apiCall as default };
